<template>
  <div
    :class="{ 'container': useContainer, 'redirect-block-select': blockParams?.isUrl }"
    @click="$emit('block:redirect')"
  >
    <div
      class="columns columns--cards"
      :style="{
        'background-color': useBackgroundColor,
        'padding-top': paddingTop + 'px',
        'padding-bottom': paddingBottom + 'px'
      }"
    >
      <page-mini-text-block
        v-for="(block, index) in blocksByTag"
        :key="index"
        :fields="convertBlockFields(block)"
      />
    </div>
  </div>
</template>

<script>
import PageMiniTextBlock from '../page-mimi-text-block/index.vue'
import staticBlockMixin from '~/mixins/staticBlockMixin'

export default {
  components: { PageMiniTextBlock },
  mixins: [staticBlockMixin]
}
</script>
